import { Modal, Box } from '@mui/material';
import { useExtraModalStore } from 'src/stores/ModalStore';
// import ExtraModalTable from './ExtraModalTable';

const ExtraModal = () => {
    const open = useExtraModalStore((state)=>state.open);
    const modalSetField = useExtraModalStore((state)=>state.setField)
    const modalReset = useExtraModalStore((state)=>state.reset)
    const modalWidth = useExtraModalStore((state)=>state.width)
    const modalpadding = useExtraModalStore((state)=>state.padding)
    const content = useExtraModalStore((state)=>state.content)

    const handleClose = () => {
        modalSetField('open',false);
        modalReset()
    }

    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                sx={{
                position: 'absolute' as const,
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 24,
                p: modalpadding,
                width: modalWidth,
                // minHeight:'772px',
                // maxHeight:'772px'
                }}>
                {content}
            </Box>
        </Modal>
    );
};

export default ExtraModal;